var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRecords(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/history/icon-records") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.2438501,15.8211587 L24.2588656,18.7279597 L21.7581127,22.0982368 L20.0514845,24.4055416 L19.6322262,24.9596977 L14.975992,27 L15.7355896,21.906801 L17.7332324,19.2216625 L20.2438501,15.8211587 Z M12.8599704,3 C14.3545032,3 15.6172107,3.97732997 16.100591,5.32745592 L20.4214184,5.32745592 C21.684126,5.32745592 22.7199408,6.37531486 22.7199408,7.65491184 L22.7199408,9.25188917 C21.9652757,9.46347607 21.2648676,9.91183879 20.7469602,10.5919395 L19.8443216,11.7808564 C19.7900646,11.8513854 19.7358076,11.9269521 19.6914156,12.0025189 L19.5681043,12.163728 C19.4941175,12.2392947 19.4250632,12.324937 19.3708062,12.4156171 L13.5850407,20.2392947 C13.3137559,20.6070529 13.1361877,21.0352645 13.0671333,21.4937028 L12.3075358,26.581864 C12.2976709,26.6423174 12.2976709,26.7027708 12.2927385,26.7632242 L5.29852236,26.7632242 C4.0358148,26.7632242 3,25.7153652 3,24.4357683 L3,7.65491184 C3,6.37531486 4.0358148,5.32745592 5.29852236,5.32745592 L9.6193498,5.32745592 C10.0977976,3.97732997 11.3654376,3 12.8599704,3 Z M10.4578665,20.7531486 L7.25177312,20.7531486 C6.64014914,20.7531486 6.14197155,21.2619647 6.14197155,21.8866499 C6.14197155,22.511335 6.64014914,23.0201511 7.25177312,23.0201511 L10.4578665,23.0201511 C11.0694905,23.0201511 11.5676681,22.511335 11.5676681,21.8866499 C11.5676681,21.2619647 11.0694905,20.7531486 10.4578665,20.7531486 Z M12.9240922,15.8312343 L7.25177312,15.8312343 C6.64014914,15.8312343 6.14197155,16.3400504 6.14197155,16.9647355 C6.14197155,17.5894207 6.64014914,18.0982368 7.25177312,18.0982368 L12.9240922,18.0982368 C13.5357162,18.0982368 14.0338938,17.5894207 14.0338938,16.9647355 C14.0338938,16.3400504 13.5357162,15.8312343 12.9240922,15.8312343 Z M22.8876441,12.2947103 C23.2181183,11.8564232 23.814945,11.7556675 24.219406,12.0730479 L26.656037,13.97733 C27.060498,14.2896725 27.114755,14.9042821 26.7842807,15.3425693 L26.2910356,15.9924433 L25.7484659,16.7229219 L21.7433154,13.8261965 L21.9948704,13.488665 L21.9850055,13.4836272 Z M16.3768082,10.9093199 L7.25177312,10.9093199 C6.64014914,10.9093199 6.14197155,11.418136 6.14197155,12.0428212 C6.14197155,12.6675063 6.64014914,13.1763224 7.25177312,13.1763224 L16.3768082,13.1763224 C16.9884322,13.1763224 17.4866098,12.6675063 17.4866098,12.0428212 C17.4866098,11.418136 16.9884322,10.9093199 16.3768082,10.9093199 Z M12.8501055,4.47607053 C11.7649662,4.47607053 10.8771249,5.38287154 10.8771249,6.49118388 C10.8771249,7.59949622 11.7649662,8.50629723 12.8501055,8.50629723 C13.9352448,8.50629723 14.823086,7.59949622 14.823086,6.49118388 C14.823086,5.38287154 13.9352448,4.47607053 12.8501055,4.47607053 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.7%",
    y: "-8.3%",
    width: "133.3%",
    height: "133.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/history/icon-records",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecords);
export default __webpack_public_path__ + "static/media/icon-records.837760bd397bdb1b0f3ee30b421e8c4f.svg";
export { ForwardRef as ReactComponent };